import React from "react";
import { Quote } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function Testimonials() {
  const { t } = useLang();
  const x = t.testimonials;
  return (
    <section className="section-y bg-brand-cloud" data-testid="testimonials-section">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 max-w-5xl">
          <div className="max-w-2xl">
            <span className="overline">{x.overline}</span>
            <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
              {x.title}
            </h2>
            <p className="mt-6 text-base md:text-lg text-brand-graphite leading-relaxed text-pretty">
              {x.body}
            </p>
          </div>
          <span className="inline-flex items-center self-start md:self-end rounded-full border border-brand-champagne bg-white px-3 py-1 text-[10px] uppercase tracking-[0.22em] font-semibold text-brand-graphite">
            {x.placeholder}
          </span>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 md:gap-6">
          {x.items.map((it, i) => (
            <figure
              key={i}
              className="card-soft card-soft-hover p-8 md:p-10 flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="h-6 w-6 text-brand-champagne" aria-hidden />
              <blockquote className="mt-5 text-base md:text-lg text-brand-ink leading-relaxed text-pretty">
                „{it.quote}"
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-brand-mist flex items-center justify-between gap-4 flex-wrap">
                <div>
                  <div className="text-sm font-medium text-brand-ink">{it.name}</div>
                  <div className="text-xs text-brand-stone">{it.role}</div>
                </div>
                <div className="text-[11px] tracking-[0.18em] uppercase font-semibold text-brand-graphite">
                  {it.product}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
